// extracted by mini-css-extract-plugin
export default {"item":"Item_item__+k0Yy","link":"Item_link__Hghz7","title":"Item_title__MNzPp","preview":"Item_preview__YXQPl","content":"Item_content__-DGm8","close":"Item_close__Ky8H2"};